import { createFormDataRequest } from "@/helpers/FormHelpers";
import Course, { CourseFormSend } from "@/interfaces/Course";
import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import api from "../api";

export const coursesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCourses: build.query<IPaginateResponse<Course>, IFilters>({
      query: (data) => {
        const params = createFormDataRequest(data);
        return {
          url: "/courses",
          params,
        };
      },
      providesTags: (result, _error, _arg) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "Courses" as const,
                id,
              })),
              { type: "Courses", id: "LIST" },
            ]
          : [],
    }),
    storeCourse: build.mutation<Course, CourseFormSend>({
      query: (body) => ({
        url: `/courses`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Courses", id: "LIST" }],
    }),
    getCourse: build.query<Course, string>({
      query: (id) => `/courses/${id}`,
      providesTags: (_result, _error, id) => [{ type: "Courses", id }],
    }),
    updateCourse: build.mutation<Course, [string, Partial<CourseFormSend>]>({
      query: ([id, body]) => ({
        url: `/courses/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, [id]) => [{ type: "Courses", id }],
    }),
    deleteCourse: build.mutation<void, string>({
      query: (id) => ({
        url: `/courses/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Courses", id: "LIST" }],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCoursesQuery,
  useLazyGetCoursesQuery,
  useStoreCourseMutation,
  useDeleteCourseMutation,
  useGetCourseQuery,
  useUpdateCourseMutation,
} = coursesApi;
